import { DEVICES_TYPES_SETTINGS } from "../enums";
import { IDeviceCategoryEnum } from "@backend/src/schemas";

const DeviceIcon: React.FC<{ deviceType: IDeviceCategoryEnum | undefined }> = ({ deviceType }) => {
  const color = deviceType != null ? DEVICES_TYPES_SETTINGS[deviceType]?.color || "#CCC" : "#CCC";

  return <div style={{ height: "10px", width: "10px", backgroundColor: color }} />;
};

export default DeviceIcon;
